<template>
  <v-app-bar
    flat
    :color="getTopBarColor"
    class="pt-4"
    app
    absolute
  >
    <v-container>
      <v-row align="center">
        <v-col
          md="4"
          xl="6"
        >
          <v-card color="transparent">
            <v-container>
              <v-row align="center">
                <v-col
                  cols="12"
                  align="center"
                >
                  <v-breadcrumbs>
                    <div class="text-h6 font-weight-black">
                      {{ $route.matched[0].name }}
                    </div>
                  </v-breadcrumbs>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
        <v-spacer />
        <v-col cols="auto">
          <ASelect
            :value="selectedRole"
            label="Emular rol"
            :items="roles"
            item-value="id"
            item-text="title"
            hide-details
            @input="(e)=>SET_SELECTED_ROLE(e)"
          />
        </v-col>
        <v-col
          xl="3"
          md="3"
        >
          <v-card
            class="card"
            color="primary"
          >
            <v-container>
              <v-row align="center">
                <v-col
                  cols="2"
                  class="py-1"
                  align="center"
                >
                  <v-icon
                    color="secondary"
                    large
                  >
                    mdi-account-circle
                  </v-icon>
                </v-col>
                <v-col
                  cols="10"
                  class="py-1"
                >
                  <div class="text-subtitle-2 font-weight-bold text--primary text-truncate">
                    {{ nombre }}
                  </div>
                  <div class="text-caption font-weight-bold text--secondary">
                    {{ perfil }}
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app-bar>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex';
import ROLES from '../roles';
import ASelect from './atoms/ASelect.vue';
import { primaryButtonProps } from './props/props';

export default {
  components: { ASelect },
  data() {
    return {
      primaryButtonProps,
      roles: [
        { id: ROLES.DIRECTOR_GENERAL, title: ROLES.DIRECTOR_GENERAL },
        { id: ROLES.DIRECTOR_AREA, title: ROLES.DIRECTOR_AREA },
        { id: ROLES.SUPERVISOR, title: ROLES.SUPERVISOR },
      ],
    };
  },

  computed: {
    ...mapGetters({
      nombre: 'getNombre',
      perfil: 'getPerfil',
      selectedRole: 'getSelectedRole',
    }),
    showTopBar() {
      if (this.loading || this.$route.name === '404' || this.$route.name === 'Login') {
        return false;
      } return true;
    },

    getTopBarColor() {
      if (this.$route.name === 'Launcher') {
        return 'white';
      } return 'primary';
    },

    items() {
      const items = [];
      this.$route.matched.forEach((route) => {
        items.push({
          text: route.name,
        });
      });
      return items;
    },
  },

  methods: {
    ...mapMutations(['SET_SNACKBAR_MESSAGE', 'SET_SELECTED_ROLE']),

    getName(name) {
      return name.split(' ', 1)[0];
    },
  },
};
</script>
